var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"lista row"},_vm._l((_vm.contenidos),function(contenido){return _c('li',{key:contenido.ContenidoDeMicrositioId,staticClass:"col-12 fuente",class:_vm.columnasContenido(contenido.TamanoDeLaColumna)},[_vm._v("\n        "+_vm._s(contenido.TextoDelContenido)+"\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102a07ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Micrositios/Formatos/ListaTexto.vue
// module id = null
// module chunks = 